<app-header (postCall)="getPostListFromHeader($event)"></app-header>
<div class="container mt-2 pt-5">
    <div class="row align-items-center">
    
    	<!--<div class="col-md-6 pr-0 order-md-1">
            <img src="img/partner.jpg" class="img-fluid">            
        </div>-->
    	
    	<div class="col-md-6 feature-txt py-4">
            <h2 class="h2">{{resourceTitle}}</h2>
            <!-- <h2 class="h2">Blogs, Whitepapers & Customer Stories.</h2> -->
            <!--<p class="text-justify">OMNI is the world's first and only aggregator of RPA platforms – get your business users to try and test any platform of their choice, build the automation workflows of their choice and
save time and increase their productivity.</p>-->
        </div>
        
        
    </div>
</div>

<div class="bg-grey pt-0">
	<div class="mob-filter desktop-hide">
    	<div class="d-flex justify-content-center">
        	<!-- <a href="#!" class="btn d-flex align-items-center shadow justify-content-center"><span class="material-icons-outlined mr-1">filter_alt</span> <span>Filter</span></a> -->
        </div>    	
    </div>
	
      <div class="container py-5 px-md-0">
      	
      	<div class="row body-content">
          <div class="col-md-6">
              <div class="search-bar">
                  <span class="material-icons-outlined input-prefix">search</span>
                  <input [(ngModel)]="searchItem" (ngModelChange)="searchPost($event)" class="search serch-icon form-control form-control-lg" type="text" placeholder="Search by name">
                  <!-- <button class="filter mob-hide"><span class="material-icons-outlined">filter_alt</span></button> -->
              </div>
          </div>
      </div>
      
      <div class="row mb-4 mt-2">
      	<div class="col">
        	<div class="quick-filter">
                  <div *ngFor="let menu of menuArray" (click)="onSelectFilter(menu)"  [ngClass]="menu.isSelected?'chip active':'chip'">{{menu.name}}</div>
                  <!-- <div class="chip">Blog</div>
                  <div class="chip">Whitepaper</div>
                  <div class="chip">Customer Stories</div> -->
              </div>
        </div>
      </div>
        <div class="row">
            <div *ngIf="posts.length == 0 && isLoading" class="col text-center align-content-center">

                <img src="../../../assets/img/loader.gif" class="loader">

            </div>
        	<div *ngFor="let post of posts" (click)="onPostClick(post)" class="col-md-4"> 
            	<a class="card blog-card">
                	<!-- <img [src]="post.image" class="img-fluid post-img"> -->
                    <div class="img-fluid img-resizer" [ngClass]="post.image ? 'background-icon' : ''" [style.background-image]="post.image ? 'url('+post.image+')' : ''"></div>
                    <div class="card-body">
                    	<p class="pb-0 m-0 font-small text-uppercase">{{post.type.name}}</p>
                        <p class="h4 m-0 clip-text">{{post.name}}</p>
                        <p class="pb-0 m-0 mt-1  font-small"> {{post.created_on | date : 'MMM dd, yyyy'}}</p>
                        
                    </div>
                </a>
            </div>

          
        </div>
      </div>
</div>
<app-footer></app-footer>
